import React, { useState } from 'react';
import AuthErrorMessage from '../messages/AuthErrorMessage';
import AuthFormLayout from '../layouts/AuthFormLayout';
import AuthNavButton from '../common/AuthNavButton';
import { FloatingLabelInput } from '../common/FloatingLabelInput';

interface ResetPasswordRequestFormProps {
  onSubmit: (email: string) => Promise<void>;
  onSwitchToSignIn: () => void;
  isLoading: boolean;
  error?: string | null;
}

const ResetPasswordRequestForm: React.FC<ResetPasswordRequestFormProps> = ({
  onSubmit,
  onSwitchToSignIn,
  isLoading,
  error,
}) => {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(email);
  };

  return (
    <AuthFormLayout
      title="Reset Password"
      footer={
        <div className="mt-4 text-center">
          <AuthNavButton onClick={onSwitchToSignIn}>Back to sign in</AuthNavButton>
        </div>
      }
      onSubmit={handleSubmit}
    >
      <AuthErrorMessage error={error} />
      <div>
        <FloatingLabelInput
          label="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          className="mt-4 w-full rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2 disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800"
          disabled={isLoading}
        >
          {isLoading ? 'Sending code...' : 'Send Reset Code'}
        </button>
      </div>
    </AuthFormLayout>
  );
};

export default ResetPasswordRequestForm;
